import { EVENTS } from 'src/constants/webSocketConsts/events';
import { upsertTagsToState, removeTagsFromState } from 'src/store/tags/actions';

const TagHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return upsertTagsToState(items);
    case EVENTS.REMOVE: {
      return removeTagsFromState(items);
    }
    default:
      break;
  }
  return null;
};

export default TagHandler;
